import { TRACKING_ENABLED, convertStrToBool } from '../../config/config';
import { getCookie } from '../../helpers/cookie';

interface AnalyticsLogEntry {
    identifier: string;
    eventName: string;
    timestamp: string;
}

export interface WindowAnalytics {
    log: AnalyticsLogEntry[];
}

/**
 * Base analytics class that allows us to:
 * - Check if cooke consent has been given.
 * - Log analytics events for dev purposes.
 */
export default class {
    readonly isAnalyticsEnabled = () => TRACKING_ENABLED && convertStrToBool(getCookie('cookie_consent'));
}
